import { atom } from "recoil";

export const authState = atom({
  key: "__app__/authState",
  default: {
    token: "",
    accountId: "",
  },
});
